// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"91a3fef4","703":"9bafb100","787":"85da30ac"}[chunkId] + ".chunk.js";
};